import { render, staticRenderFns } from "./PlaceSelectionSelectTab.vue?vue&type=template&id=165b36c6&scoped=true&"
import script from "./PlaceSelectionSelectTab.vue?vue&type=script&lang=js&"
export * from "./PlaceSelectionSelectTab.vue?vue&type=script&lang=js&"
import style0 from "./PlaceSelectionSelectTab.vue?vue&type=style&index=0&id=165b36c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165b36c6",
  null
  
)

export default component.exports